import { useState } from "react";
import Header from "../components/Header";
import Footer from "../components/Footer";
import { forgotPassword } from "../api/auth.api";
import { useTranslation } from "react-i18next";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [status, setStatus] = useState("idle"); // idle | loading | success | error
  const { t } = useTranslation();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setStatus("loading");

    try {
      await forgotPassword(email);
      setStatus("success");
    } catch {
      setStatus("error");
    }
  };

  return (
    <div className="content">
    <Header />
    <div>
      {status === "success" ? (
        <div style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          minHeight: "60vh",
          fontSize: "18px"
        }}>
          <p>
            {t("auth.forgotPassword.success")}
          </p>
        </div>
      ) : (
        <form className="login-form" onSubmit={handleSubmit}>

          {/*<img className="login-logo" alt="Data optimizer Logo" src="./data-optimizer-logo.png" />*/}
          <h2 className="login-headline">{t("auth.forgotPassword.title")}</h2>
          
          <input
            data-testid="forgot-email"
            placeholder={t("auth.forgotPassword.emailPlaceholder")}
            value={email}
            onChange={(e) => setEmail(e.target.value)}
          />
          <button className="form-button" type="submit" disabled={status === "loading"}>
            {status === "loading" ? t("auth.forgotPassword.loading") : t("auth.forgotPassword.submit")}
          </button>
        </form>
      )}

      {status === "error" && (
        <p style={{ color: "red" }}>{t("auth.forgotPassword.error")}</p>
      )}
    </div>
    <Footer />
    </div>
  );
}